<template>
  <v-container fluid>
    <div
      class="d-flex"
      style="height: 80vh; border: 1px solid #ccc; position: relative; overflow: hidden;"
    >
      <!-- Main Content -->
      <div class="flex-grow-1 pa-4">
        <h3>Main Content</h3>
        <p>This content remains accessible even when the panel is open.</p>

        <!-- Buttons to switch content -->
        <v-btn small @click="setPanel('notes')">Show Notes</v-btn>
        <v-btn small @click="setPanel('map')">Show Map</v-btn>
      </div>

      <!-- Buttons to toggle panel -->
      <div class="pa-2">
        <v-btn @click="panelOpen = !panelOpen" icon>
          <v-icon>{{
            panelOpen ? "mdi-chevron-right" : "mdi-chevron-left"
          }}</v-icon>
        </v-btn>
      </div>

      <!-- Sliding Panel -->
      <transition name="slide-panel">
        <div
          v-if="panelOpen"
          class="panel"
          :style="{ width: panelWidth + 'px' }"
        >
          <v-toolbar flat dense>
            <v-toolbar-title>{{
              panelType === "notes" ? "Notes" : "Map"
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="panelOpen = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-container>
            <!-- Dynamic content -->
            <div v-if="panelType === 'notes'">
              <p>Your notes content goes here.</p>
            </div>
            <div v-else-if="panelType === 'map'">
              <p>Your map content goes here.</p>
            </div>
          </v-container>
        </div>
      </transition>
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      panelOpen: true, // Panel open by default
      panelType: "notes" // Default panel content
    };
  },
  computed: {
    panelWidth() {
      return this.panelType === "notes" ? 300 : 600;
    }
  },
  methods: {
    setPanel(type) {
      this.panelType = type;
      this.panelOpen = true; // Open panel if closed
    }
  }
};
</script>

<style scoped>
.panel {
  height: 100%;
  background: #ffffff;
  box-shadow: -4px 0 8px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  transition: width 0.3s ease; /* Smooth transition on width change */
}

.slide-panel-enter-active,
.slide-panel-leave-active {
  transition: transform 0.3s ease;
}

.slide-panel-enter {
  transform: translateX(100%);
}

.slide-panel-leave-to {
  transform: translateX(100%);
}
</style>
